import React, { useCallback, useEffect, useState } from "react";
import { createCocreationToolsLaunch } from "../services/cocreationSso";
import { LoadingState } from "./LoadingState";

export const CocreationLaunchPage = ({ token }: { token: string | null }) => {
  const [attempt, setAttempt] = useState(0);
  const [error, setError] = useState(false);
  const retry = useCallback(() => {
    setError(false);
    setAttempt((value) => value + 1);
  }, []);

  useEffect(() => {
    let active = true;
    void createCocreationToolsLaunch(token)
      .then((launchUrl) => {
        if (active) window.location.replace(launchUrl);
      })
      .catch(() => {
        if (active) setError(true);
      });
    return () => { active = false; };
  }, [attempt, token]);

  if (error) {
    return (
      <main className="app-shell unauth">
        <div className="card auth-card" role="alert">
          <h1>Cocreation Tools could not be opened</h1>
          <p>Your secure handoff could not be completed. Try again, or return to Panel Insights.</p>
          <button className="primary-btn" type="button" onClick={retry}>Try Again</button>
        </div>
      </main>
    );
  }

  return (
    <main className="app-shell unauth">
      <LoadingState label="Opening Cocreation Tools..." layout="page" />
    </main>
  );
};
